import { render, staticRenderFns } from "./addition.vue?vue&type=template&id=3588377c"
import script from "./addition.vue?vue&type=script&lang=js"
export * from "./addition.vue?vue&type=script&lang=js"
import style0 from "./addition.vue?vue&type=style&index=0&id=3588377c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports